export enum EssayStatus {
    Discarded = -1,
    Draft = 0,
    Pending = 1,
    CorrectorPending = 2,
    Corrected = 3
}
